import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { UserService } from './api/user.service';
import { GasStationsService } from './api/gasStations.service';
import { TrailerService } from './api/trailer.service';
import { OrderService } from '@core/api/api/order.service';
import { GasNetworksService } from '@core/api/api/gasNetworks.service';
import { SettingsService } from '@core/api/api/settings.service';
import {LogService} from "@core/api/api/log.service";
import {DeferredUpdateService} from "@core/api/api/deferredUpdate.service"

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    UserService,
    GasStationsService,
    TrailerService,
    OrderService,
    GasNetworksService,
    SettingsService,
    LogService,
    DeferredUpdateService
  ]
})
export class ApiModule {
  constructor(@Optional() @SkipSelf() parentModule: ApiModule,
              @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
        'See also https://github.com/angular/angular/issues/20575');
    }
  }

  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }]
    };
  }
}
